
import React, { createContext, useContext, useState } from 'react';
import { useToast } from './ToastProvider';
import { Result } from '@peercolab/engine';
import { Session } from '../peer-colab-model/Session';
import { TrainerManagment } from '../peer-colab-model/PetKey/BackofficeFE/Client/PathItems';
import { Trainer } from '../peer-colab-model/PetKey/Main/Model/1_0_Initial/Backoffice/Trainers/PathItems';

type TrainerContextType = {
  trainers: Trainer[];
  loadTrainers: () => Promise<Result<Trainer[]>>
};

const TrainerContext = createContext<TrainerContextType | undefined>(undefined);

export const TrainerProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { onError } = useToast();
  const [trainers, setTrainers] = useState<Trainer[]>([]);

  const loadTrainers = async (): Promise<Result<Trainer[]>> => {
    return onError((await Session.getClient().request(TrainerManagment.searchTrainer({ query: '', limit: 10000, offset: 0 })))
      .maybePassThroughOk((match) => {
        setTrainers([...match]);
      }));
  }

  return (
    <TrainerContext.Provider value={{ trainers, loadTrainers }}>
      {children}
    </TrainerContext.Provider>
  );
};

export function useTrainers() {
  const ctx = useContext(TrainerContext);
  if (!ctx) throw new Error('useTrainers must be used within a TrainerProvider');
  return ctx;
}
